import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="login_footer">
      <div className="login_footer_wrap">
        <Link to="/">English(UK)</Link>
        <Link to="/">Français(FR)</Link>
        <Link to="/">العربية</Link>
        <Link to="/">ⵜⴰⵎⴰⵣⵉⵖⵜ</Link>
        <Link to="/">Español (España)</Link>
        <Link to="/">italiano</Link>
        <Link to="/">Deutsch</Link>
        <Link to="/">Português (Brasil)</Link>
        <Link to="/">हिन्दी</Link>
        <Link to="/">中文(简体)</Link>
        <Link to="/">日本語</Link>
        <Link to="/" className="footer_square">
          <i className="plus_icon"></i>
        </Link>
      </div>
      <div className="footer_splitter"></div>
      <div className="login_footer_wrap">
        <Link to="/">Arilux</Link>
        <Link to="/">BM-Stúdio</Link>
        <Link to="/">AB</Link>
        <Link to="/">Aristóbulo Luxo</Link>
        <Link to="/">Zap</Link>
        <Link to="/">E-commerce</Link>
        <Link to="/">Unikivi</Link>
        <Link to="/">Wallet-service</Link>
        <Link to="/">Pá-Quilén</Link>
        <Link to="/">Unitel</Link>
        <Link to="/">Portal</Link>
        <Link to="/">Voting</Link>
        <Link to="/">Valência</Link>
        <Link to="/">Beatriz@David</Link>
        <Link to="/">History</Link>
        <Link to="/">Movie</Link>
        <Link to="/">Gabinete Provincial de Comunicação Social</Link>
        <Link to="/">Groups</Link>
        <Link to="/">E-shop</Link>
        <Link to="/">Almeida@Sebastião</Link>
        <Link to="/">Booking</Link>
        <Link to="/">Find Job</Link>
        <Link to="/">Quiz</Link>
        <Link to="/">Premmium</Link>
        <Link to="/">GPU</Link>
        <Link to="/">
          AdChoices
          <i className="adChoices_icon"></i>
        </Link>
        <Link to="/">Terms</Link>
        <Link to="/">Help</Link>
      </div>
      <div className="login_footer_wrap">
        <Link to="/" style={{ fontSize: "12px", marginTop: "10px" }}>
          Aristóbulo Luxo * 2026
        </Link>
      </div>
    </footer>
  );
}
